import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=c8190020&scoped=true&"
import script from "./AccountActivation.vue?vue&type=script&lang=js&"
export * from "./AccountActivation.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivation.vue?vue&type=style&index=0&id=c8190020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8190020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
